import { DataType } from '@/domains/base/enums/data-type';
import { INVESTMENT_COLUMNS_MAP } from './investment';
import { MARKET_COLUMNS_MAP } from './market';
import { PAPER_COLUMNS_MAP } from './paper';
import { PATENT_COLUMNS_MAP } from './patent';
import { MERGER_COLUMNS_MAP } from './merger';
export const CELL_CONFIG_MAP = {
    [DataType.PATENT]: PATENT_COLUMNS_MAP,
    [DataType.PAPER]: PAPER_COLUMNS_MAP,
    [DataType.MARKET]: MARKET_COLUMNS_MAP,
    [DataType.INVESTMENT]: INVESTMENT_COLUMNS_MAP,
    [DataType.MERGER]: MERGER_COLUMNS_MAP,
};
